export const POPULAR_ITEMS_LIMIT = 8;
